import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";

import useMutate from "../../../../../hooks/useMutate";
import { clearCheckedIds } from "../../../../../redux/CheckboxSlice";
import { moveWorklog } from "../../../../../services/apiWorklog";
import { objectToFormData } from "../../../../../utils";

export function useMoveWorklogMutation({
  cardId,
  boardId,
  currentCardId,
  selectedIds,
  onComplete,
}) {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const { mutate } = useMutate(
    moveWorklog,
    ["teams", "watching", "mineCards"],
    () => {},
    () => {
      queryClient.invalidateQueries({
        queryKey: ["worklog", currentCardId],
      });
      queryClient.invalidateQueries({
        queryKey: ["card", currentCardId],
      });
      queryClient.invalidateQueries({
        queryKey: ["cards", boardId],
      });
      queryClient.invalidateQueries({ queryKey: ["teams"] });
      queryClient.invalidateQueries({ queryKey: ["watching"] });
      queryClient.invalidateQueries({ queryKey: ["mineCards"] });
      dispatch(clearCheckedIds());
      onComplete?.();
    },
    () => {
      onComplete?.();
    }
  );

  const moveSelectedWorklogs = useCallback(
    (newCardId) => {
      mutate(
        objectToFormData({
          existing_card_id: cardId,
          new_card_id: newCardId,
          card_log_ids: selectedIds,
        })
      );
    },
    [cardId, mutate, selectedIds]
  );

  return { moveSelectedWorklogs };
}
